<template>
  <gh-page :drawer="true" :is-mini="false">
    <template #left_draw_top="{mini}">
      <v-layout row align-center v-show="!mini">
        <v-progress-linear color="success" v-show="serviceMethods.get_roles.isBusy"
          :indeterminate="serviceMethods.get_roles.isBusy">
        </v-progress-linear>
        <v-btn icon @click="fetchRoles()" flat>
          <v-icon color="primary">mdi-refresh</v-icon> 刷新
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon flat color="success" @click="configRole()">
          <v-icon>
            mdi-account-plus
          </v-icon> 配置角色
        </v-btn>
      </v-layout>
    </template>
    <template #left-drawer>
      <v-layout column>
        <v-divider></v-divider>
        <v-list>
          <template v-for="item in serviceMethods.get_roles.data">
            <v-list-tile avatar @click="clickMenu(item)">
              <v-list-tile-avatar>
                <v-icon color="primary">mdi-account</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                {{item.Name}}
                <v-list-tile-sub-title> {{item.Demo}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox v-model="selectedRole[item.Id]" readonly></v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </template>

        </v-list>
      </v-layout>

    </template>
    <template #toolbar>
        <span style="font-size:14px;color:gray;margin-left:30px;">当前角色：</span>
        <span class="title">{{selected.Name}}</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="fetchMenus()">刷新</v-btn>
        <v-btn color="success" @click="save">保存</v-btn>
    </template>
    <v-divider></v-divider>
    <v-container pa-0 background-color="white">
      <v-card color="white" style="height:750px;overflow:auto">
        <v-layout column>
          <v-layout row wrap>
            <el-tree style="width: 100%" ref="treeMenus" :data="serviceMethods.get_all_menus.data" default-expand-all
              show-checkbox node-key="Id" :default-checked-keys="permissions">
              <div slot-scope="{node,data}" style="width: 100%">
                <v-icon small color="primary">{{data.icon}}</v-icon>{{data.Name}}
              </div>
            </el-tree>
          </v-layout>

        </v-layout>
      </v-card>


    </v-container>

  </gh-page>
</template>

<style scoped>

</style>

<script>
  import Permission from "./permission.ts";
  export default Permission;
</script>